/**
 * オブジェクトから特定のキーを削除する
 * @param {object} obj 対象オブジェクト
 * @param  {...string} keys 除外するキー
 * @returns {object} 結果オブジェクト
 */
export function objExcept(obj, ...keys) {
  let res = {}
  Object.keys(obj).forEach(key => {
    if (!keys.includes(key)) {
      res[key] = obj[key]
    }
  })
  return res
}

/**
 * オブジェクトから対象となるキーの値を取り出す<br />
 * キーが見つからなかったときはデフォルト値を返す
 * @param {object} obj 対象オブジェクト
 * @param {string} key キー
 * @param {*} defaultVal キーが見つからなかったときの返却値
 * @returns {*} 取得結果
 */
export function objGet(obj, key, defaultVal = null) {
  return typeof obj[key] === 'undefined' ? defaultVal : obj[key]
}
